/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineExperienceBucket } from './pipelineExperienceBucket';
import type { PipelineFilterFacet } from './pipelineFilterFacet';
import type { PipelineSequenceFacet } from './pipelineSequenceFacet';

/**
 * Selectable values for the pipeline filter panel.
 *
 * Only the data-derived facets live here: origins and sync states are read off
 * the job's own rows so the panel never offers a value that matches nothing,
 * and sequences are read off the job itself so an unenrolled one is still
 * selectable. The fixed vocabularies (enrollment status, social network,
 * relative window) are typed in the generated client and labelled by the panel
 * that renders them.
 *
 * ``experience_years`` is a distribution rather than a list of choices: the
 * panel draws it behind the years range slider so the range is picked against
 * the shape of the pipeline, not blind. Empty when no candidate on the job has
 * known experience.
 */
export interface PipelineFilterOptionsResponse {
  origins?: PipelineFilterFacet[];
  ats_sync_states?: PipelineFilterFacet[];
  sequences?: PipelineSequenceFacet[];
  experience_years?: PipelineExperienceBucket[];
}
